module.exports = __webpack_public_path__ + "img/healthy-menu-hpb.c4240518.png";